import { Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { Toast, ToastTypeEnum } from '../components/organisms/toast/toast.type';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toasts: WritableSignal<Toast[]> = signal([]);
  private currentId = 0;

  public addToast(message: string, type: ToastTypeEnum = ToastTypeEnum.SUCCESS): void {
    const toast: Toast = { id: ++this.currentId, message, type };
    this.toasts.update((arr) => [...arr, toast]);

    // Remove toast after 5 seconds
    setTimeout(() => this.removeToast(toast.id), 5000);
  }

  public getToasts(): Signal<Toast[]> {
    return this.toasts.asReadonly();
  }

  public removeToast(id: number) {
    this.toasts.update((arr) => arr.filter((toast) => toast.id !== id));
  }
}
